var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillDataSampleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EBFBED"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3056_10846)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3056_10846",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 29,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H42.6667V44H14V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3056_10846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4649 22.8242V21.5085C40.4649 20.5967 40.1404 19.7224 39.5629 19.0777L34.5444 13.4757C33.9669 12.831 33.1836 12.4688 32.3669 12.4688H30.5946",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4646 39.3363V40.7806C40.4646 42.2994 39.3616 43.5312 38.0011 43.5312H18.6656C17.3051 43.5312 16.2015 42.2994 16.2015 40.7806V15.2188C16.2015 13.7 17.3051 12.4688 18.6656 12.4688H31.8411C32.836 12.4688 33.6423 13.3694 33.6423 14.48V17.3344C33.6423 18.8531 34.7453 20.0844 36.1064 20.0844H38.6634C39.6583 20.0844 40.4646 20.985 40.4646 22.0956V37.4625",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5502 22.521H34.9563C36.234 22.521 37.2704 23.6772 37.2704 25.1041V36.9804C37.2704 38.4066 36.234 39.5635 34.9563 39.5635H21.7103C20.4321 39.5635 19.3963 38.4066 19.3963 36.9804V25.1041C19.3963 24.0022 20.0144 23.0616 20.8845 22.691",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5405 39.5625H25.1261V22.5199H31.5405V39.5625Z",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3963 26.7598H37.2703",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3963 31.042H37.2703",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3963 35.3232H37.2703",
    stroke: "#0D672C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3056_10846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6667,
    height: 32,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillDataSampleIcon);
export default __webpack_public_path__ + "static/media/fillDataSampleIcon.c2852b1a86435ad52ab4b41455a3fdf1.svg";
export { ForwardRef as ReactComponent };